import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
} from '@fortawesome/pro-regular-svg-icons';
import type { ChecklistAction } from '../../types';
import styles from './ActionCard.module.css';

interface Props {
  action: ChecklistAction;
}

export default function ChecklistCard({ action }: Props) {
  return (
    <div className={styles.card}>
      {action.title && <div className={styles.cardTitle}>{action.title}</div>}
      {action.items.map((item, idx) => (
        <div key={idx} className={styles.checklistItem}>
          <FontAwesomeIcon
            icon={item.status === 'pass' ? faCircleCheck : faCircleXmark}
            className={
              item.status === 'pass'
                ? styles.checklistPass
                : styles.checklistFail
            }
          />
          <span>{item.label}</span>
          {item.detail && (
            <span className={styles.checklistDetail}>{item.detail}</span>
          )}
        </div>
      ))}
    </div>
  );
}
